var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3076_238302)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5001 41.86C34.9213 41.86 44.1801 32.6013 44.1801 21.18C44.1801 9.75875 34.9213 0.5 23.5001 0.5C12.0788 0.5 2.82007 9.75875 2.82007 21.18C2.82007 27.6109 5.7555 33.3563 10.3596 37.1492C10.3669 37.1552 10.3604 37.1669 10.3514 37.1639V37.1639C10.3458 37.162 10.3401 37.1661 10.3401 37.1719V41.9452C10.3401 44.4929 13.0254 46.1464 15.3003 44.9996L20.6696 42.293C21.333 41.9586 22.0763 41.825 22.8189 41.849C23.045 41.8563 23.2721 41.86 23.5001 41.86Z",
    fill: "#045762"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3076_238302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6339 16.8205L32.3139 17.2605C32.3139 17.2705 32.3139 17.2705 32.3039 17.2805L22.7939 30.7805C22.5538 31.1335 22.2321 31.4233 21.856 31.6252C21.48 31.8271 21.0607 31.9353 20.6339 31.9405H20.5839C20.1638 31.9397 19.7497 31.8407 19.3747 31.6515C18.9996 31.4622 18.6741 31.1879 18.4239 30.8505L13.8139 24.9104C13.7539 24.8505 13.7139 24.7805 13.6639 24.7205C13.291 24.2523 13.0617 23.6862 13.0039 23.0905C12.9936 22.9265 13.0037 22.7619 13.0339 22.6005C13.1032 22.0943 13.3227 21.6206 13.6639 21.2405C14.1414 20.7259 14.8026 20.4204 15.5039 20.3904C16.161 20.3782 16.7979 20.6179 17.2839 21.0604C17.352 21.1151 17.4155 21.1754 17.4739 21.2404L17.7739 21.6403C17.7777 21.6443 17.7805 21.649 17.7823 21.6542C17.784 21.6594 17.7846 21.6649 17.7839 21.6703L20.5439 25.3903L28.1739 14.3003L28.4039 13.9704C28.4304 13.9247 28.4605 13.8813 28.4939 13.8404C28.7323 13.5782 29.0224 13.3682 29.346 13.2236C29.6695 13.0791 30.0195 13.003 30.3739 13.0004C31.02 12.9894 31.6459 13.2255 32.1239 13.6603C32.4952 13.9828 32.7572 14.4125 32.8739 14.8903C32.9636 15.2119 32.9885 15.5481 32.9474 15.8794C32.9062 16.2108 32.7996 16.5306 32.6339 16.8205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3076_238302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3076_238302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9672,
    height: 18.9403,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b5eacf8aa444e942c7345cd5eaa94023.svg";
export { ForwardRef as ReactComponent };